import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOrderLineItemsByVersionAndOrderID(orderId) {
  const response = await $.soap({
    body: {
      GetOrderLineItemsByVersionAndOrderID: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_line_item',
        OrderID: orderId
      }
    },
    blueprintArrays: ['GetOrderLineItemsByVersionAndOrderIDResponse'],
    blueprint: {
      lineItems: [
        '$..tuple',
        {
          id: '$..ID',
          formTypeId: '$..FormTypeID',
          imgUrl: '$..ImgUrl',
          csDataSheetId: '$..CSDataSheetID',
          clin: '$..CLIN',
          price: '$..Price',
          volumeBand: '$..VolumeBand',
          model: '$..Model',
          laserPrinterTonerCartridgeType: '$..LaserPrinterTonerCartridgeType',
          description: '$..Description',
          paperCapacityHandling: '$..PaperCapacityHandling',
          configurationAndPricing: '$..ConfigurationAndPricing',
          serviceAcronym: '$..ServiceAcronym',
          speedPPM: '$..SpeedPPM',
          isColor: '$..IsColor',
          isNIPR: '$..IsNIPR',
          monthlyVolume: '$..MonthlyVolume',
          estimatedMonthlyVolumeMono: '$..EstimatedMonthlyVolumeMono',
          estimatedMonthlyVolumeColor: '$..EstimatedMonthlyVolumeColor',
          deliveryTypeId: '$..DeliveryTypeID',
          chargesFrequencyId: '$..ChargesFrequencyID',
          panel: '$..Panel',
          compatibleDevice: '$..CompatibleDevice',
          warrantyYear: '$..WarrantyYear',
          version: '$..Version',
          versionStartDate: '$..VersionStartDate',
          isActive: '$..IsActive'
        }
      ]
    }
  });
  _.each(response.lineItems, (item) => {
    if (item.compatibleDevice && typeof item.compatibleDevice === 'string') {
      // For some reason it does not render correctly if you just set the cleaned string to compatibleDeviceKey
      item.compatibleDevice = item.compatibleDevice;
      item.compatibleDeviceKey = item.compatibleDevice.replace(/[\W_]+/g, '');
    }
    item.formattedPrice =  parseInt(item.price).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  });
  cleanUpResponse(response);
  return response.lineItems;
}